import React from "react";
import { GoDotFill } from "react-icons/go";

const ProductSideCard = ({ bulletPoints }) => {
  let data = bulletPoints;

  try {
    // Do not redeclare 'data' here!
    if (!data) data = [];
    else if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch (e) {
        data = [];
      }
    } else if (typeof data === "object") {
      if (Array.isArray(data)) {
        data = data;
      } else {
        data = Object.values(data); // this handles {"0": "...", "1": "..."} type
      }
    } else {
      data = [];
    }
  } catch (e) {
    console.error("Error parsing bullet points:", e);
    data = [];
  }

  return (
    <div>
      {data.length > 0 ? (
        <ul className="my-0">
          {data.map((el, index) => (
            <li className="flex items-center py-3" key={index}>
              <span className="text-xl text-gray-400 items-start mr-4">
                <GoDotFill />
              </span>
              <p className="font-sans leading-5 text-sm text-gray-500">{el}</p>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-400 text-sm">No bullet points available.</p>
      )}
    </div>
  );
};

export default ProductSideCard;
